import React from 'react';
import styled from 'styled-components';

const ControlPadWrapper = styled.div`
  display: none; /* 默认在桌面端隐藏 */
  position: fixed; /* 固定位置，不随滚动变化 */
  left: 0;
  right: 0;
  bottom: 30px; /* 离底部一定距离 */
  z-index: 100;
  pointer-events: none; /* 默认不拦截点击事件，让下层元素可点击 */
  
  @media (max-width: 768px) {
    display: flex; /* 在移动端显示 */
    justify-content: space-between; /* 左右两侧分布 */
    padding: 0 10px;
  }
`;

const ControlSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: auto; /* 恢复点击事件 */
`;

// 左侧控制区（移动）
const LeftControls = styled(ControlSide)`
  padding-right: 20px;
`;

// 右侧控制区（旋转和功能按钮）
const RightControls = styled(ControlSide)`
  padding-left: 20px;
`;

const ControlRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 5px 0;
`;

const ControlButton = styled.button`
  width: 55px;
  height: 55px;
  margin: 4px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 191, 255, 0.75);
  color: white;
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-tap-highlight-color: transparent;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  -webkit-touch-callout: none;
  user-select: none;
  backdrop-filter: blur(3px); /* 模糊背景，增加半透明效果 */
  
  &:active {
    background: rgba(0, 153, 204, 0.8);
    transform: scale(0.95);
  }
`;

const LargeButton = styled(ControlButton)`
  width: 70px;
  height: 55px;
  border-radius: 27px;
  font-size: 0.9rem;
  margin-top: 10px;
`;

const MobileControls = ({ onMove, onRotate, onDrop, onHardDrop, onPause }) => {
  return (
    <ControlPadWrapper>
      {/* 左侧控制区：方向控制 */}
      <LeftControls>
        <ControlRow>
          <ControlButton 
            onClick={() => onMove(-1, 0)} 
            aria-label="左移"
          >
            ←
          </ControlButton>
        </ControlRow>
        
        <ControlRow>
          <ControlButton 
            onClick={() => onMove(0, 1)} 
            aria-label="下降"
          >
            ↓
          </ControlButton>
        </ControlRow>
        
        <ControlRow>
          <ControlButton 
            onClick={() => onMove(1, 0)} 
            aria-label="右移"
          >
            →
          </ControlButton>
        </ControlRow>
      </LeftControls>
      
      {/* 右侧控制区：旋转和功能按钮 */}
      <RightControls>
        <ControlRow>
          <ControlButton 
            onClick={onRotate}
            aria-label="旋转"
          >
            ↻
          </ControlButton>
        </ControlRow>
        
        <ControlRow>
          <LargeButton 
            onClick={onHardDrop} 
            aria-label="直接落下"
          >
            落下
          </LargeButton>
        </ControlRow>
        
        <ControlRow>
          <LargeButton 
            onClick={onPause} 
            aria-label="暂停"
          >
            暂停
          </LargeButton>
        </ControlRow>
      </RightControls>
    </ControlPadWrapper>
  );
};

export default MobileControls;